var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandMicrosoftStyleWhite = function SvgBrandMicrosoftStyleWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.043 1.043h10.435v10.435H1.043zM12.522 1.043h10.434v10.435H12.522zM1.043 12.522h10.435v10.434H1.043zM12.522 12.522h10.434v10.434H12.522z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandMicrosoftStyleWhite);
export { ForwardRef as ReactComponent };